import { Component, OnInit, HostListener } from '@angular/core';
import {CommonUtil} from '../../../../utils/common.util';
import {ConstantUtils} from '../../../../utils/constant.utils';

@Component({
  selector: 'app-enquiry-page-header',
  templateUrl: './enquiry-page-header.component.html',
  styleUrls: ['./enquiry-pageheader.scss']
})

export class EnquiryPageHeaderComponent implements OnInit {

  public CURRENT_YEAR = CommonUtil.getCurrentAcademicYear();
  public schoolName;

  ngOnInit() {

    const bootstrapData = JSON.parse(localStorage[ConstantUtils.BOOTSTRAP]);
    const schoolData = bootstrapData['school'];
    this.schoolName = schoolData['school_name'];

    $('#search').on('click', function (e) {
      e.preventDefault();
      $('.search-box').fadeIn().addClass('display');
    });
    $('.dismiss').on('click', function () {
      $('.search-box').fadeOut().removeClass('display');
    });

    $('#toggle-btn').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');

      $('#sidebar').toggleClass('shrinked');
      $('.content-inner').toggleClass('active');
      $('.sub-menus').removeClass('show');
      $(document).trigger('sidebarChanged');

      if ($(window).outerWidth() > 1183) {
        if ($('#toggle-btn').hasClass('active')) {
          $('.navbar-header .brand-small').hide();
          $('.navbar-header .brand-big').show();
        } else {
          $('.navbar-header .brand-small').show();
          $('.navbar-header .brand-big').hide();
        }
      }
    });

    const windowWidth = $(window).outerWidth();
    if (windowWidth <= 1183) {
      $('#sidebar').addClass('shrinked');
      $('.navbar-header .brand-small').show();
      $('.navbar-header .brand-big').hide();
      $('.content-inner').addClass('active');

    } else {
      $('#sidebar').removeClass('shrinked');
      $('.navbar-header .brand-small').hide();
      $('.navbar-header .brand-big').show();
      $('.content-inner').removeClass('active');
    }
    // upload sidebar
    $('#dismiss, .overlay').on('click', function () {
      $('#sidebar-upload').removeClass('active');
      $('.overlay').removeClass('active');
  });

  $('#sidebarCollapse').on('click', function () {
      $('#sidebar-upload').addClass('active');
      $('.overlay').addClass('active');
      $('.collapse.in').toggleClass('in');
      $('a[aria-expanded=true]').attr('aria-expanded', 'false');
  });
  }

  @HostListener('window:resize', ['$event'])
  public onResize() {
    const windowWidth = $(window).outerWidth();
    if (windowWidth <= 1199) {
      $('#sidebar').addClass('shrinked');
      $('.navbar-header .brand-small').show();
      $('.navbar-header .brand-big').hide();
      $('.content-inner').addClass('active');

    } else {
      $('#sidebar').removeClass('shrinked');
      $('.navbar-header .brand-small').hide();
      $('.navbar-header .brand-big').show();
      $('.content-inner').removeClass('active');
    }
  }
}
